module.exports = __webpack_public_path__ + "img/Skills.aa2b3edd.svg";